import { Routes, Route, Navigate } from 'react-router-dom';

import AuthGuard from './components/AuthGuard.jsx';
import Home from './pages/Home.jsx';
import Login from './pages/Login.jsx';
import Settings from './pages/Settings.jsx';
import Stock from './pages/Stock.jsx';
import Sales from './pages/Sales.jsx';
import SaleDetail from './pages/SaleDetail.jsx';
import NewSale from './pages/NewSale.jsx';
import EditSale from './pages/EditSale.jsx';
import Quotes from './pages/Quotes.jsx';
import QuoteDetail from './pages/QuoteDetail.jsx';
import NewQuote from './pages/NewQuote.jsx';
import EditQuote from './pages/EditQuote.jsx';
import ReleaseNote from './pages/ReleaseNote.jsx';
import CaptureExpense from './pages/CaptureExpense.jsx';
import Customers from './pages/Customers.jsx';
import CustomerDetail from './pages/CustomerDetail.jsx';
import NewCustomer from './pages/NewCustomer.jsx';

// XENERGY Mobile — top-level router.
//
// Phase A: Login + AuthGuard wrap protected routes. Login is the only
// public route; everything else falls back to /login when no tokens are
// in the auth store.
//
// Subsequent phases will add NewSale, NewQuote, Stock, CaptureExpense per
// docs/PWA_BRIEF.md §10. They'll all be wrapped in <AuthGuard>.

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/"
        element={
          <AuthGuard>
            <Home />
          </AuthGuard>
        }
      />
      <Route
        path="/settings"
        element={
          <AuthGuard>
            <Settings />
          </AuthGuard>
        }
      />

      <Route
        path="/stock"
        element={
          <AuthGuard>
            <Stock />
          </AuthGuard>
        }
      />
      <Route
        path="/sales"
        element={
          <AuthGuard>
            <Sales />
          </AuthGuard>
        }
      />
      {/* /sales/new must be declared BEFORE /sales/:id so the literal segment
          matches first and "new" is never interpreted as an :id. React Router
          v6 handles specificity automatically, but ordering is also defensive. */}
      <Route
        path="/sales/new"
        element={
          <AuthGuard>
            <NewSale />
          </AuthGuard>
        }
      />
      {/* /sales/:id/edit before /sales/:id so the more-specific path
          matches first. React Router v6 handles specificity automatically
          but ordering is also defensive. */}
      <Route
        path="/sales/:id/edit"
        element={
          <AuthGuard>
            <EditSale />
          </AuthGuard>
        }
      />
      <Route
        path="/sales/:id"
        element={
          <AuthGuard>
            <SaleDetail />
          </AuthGuard>
        }
      />
      <Route
        path="/quotes"
        element={
          <AuthGuard>
            <Quotes />
          </AuthGuard>
        }
      />
      {/* /quotes/new before /quotes/:id so the literal segment matches first. */}
      <Route
        path="/quotes/new"
        element={
          <AuthGuard>
            <NewQuote />
          </AuthGuard>
        }
      />
      {/* /quotes/:id/edit before /quotes/:id so the more-specific path
          matches first (same defensive ordering as /sales/:id/edit). */}
      <Route
        path="/quotes/:id/edit"
        element={
          <AuthGuard>
            <EditQuote />
          </AuthGuard>
        }
      />
      <Route
        path="/quotes/:id"
        element={
          <AuthGuard>
            <QuoteDetail />
          </AuthGuard>
        }
      />
      {/* Release notes are reached via deeplink from a Sale (no list page
          on mobile yet — desktop owns the index view). */}
      <Route
        path="/release-notes/:id"
        element={
          <AuthGuard>
            <ReleaseNote />
          </AuthGuard>
        }
      />
      <Route
        path="/expenses/capture"
        element={
          <AuthGuard>
            <CaptureExpense />
          </AuthGuard>
        }
      />

      <Route
        path="/customers"
        element={
          <AuthGuard>
            <Customers />
          </AuthGuard>
        }
      />
      {/* /customers/new before /customers/:id so the literal segment
          matches first (same defensive ordering as /sales/new and
          /quotes/new). */}
      <Route
        path="/customers/new"
        element={
          <AuthGuard>
            <NewCustomer />
          </AuthGuard>
        }
      />
      <Route
        path="/customers/:id"
        element={
          <AuthGuard>
            <CustomerDetail />
          </AuthGuard>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
